/* KDK-PERF V3 3.0.0 — read-only cart count coordination. No fetch interception. */
(function (window, document) {
  'use strict';
  var api = window.KDKThemeV3 = window.KDKThemeV3 || {};
  if (api.cart) return;
  api.version = '3.0.0';
  var config = window.KDKThemeV3Config || {};
  var count = Number.isInteger(config.initialCartCount) ? config.initialCartCount : null;
  var revision = 0, valueRevision = 0, nativePending = null, inFlight = null;
  var timer = null, dirty = false;
  var stats = { reads: 0, coalesced: 0, staleDiscarded: 0, nativeResults: 0 };

  function paint(value) {
    if (!Number.isInteger(value) || value < 0) return false;
    count = value;
    document.querySelectorAll('.cart-count, .Header__CartCount').forEach(function (node) {
      if (node.textContent !== String(value)) node.textContent = String(value);
    });
    document.querySelectorAll('.Header__CartDot').forEach(function (node) {
      node.classList.toggle('is-visible', value > 0);
    });
    return true;
  }
  function clearTimer() { if (timer !== null) { window.clearTimeout(timer); timer = null; } }
  function cartUrl() {
    if (window.routes && window.routes.cartUrl) return window.routes.cartUrl.replace(/\/$/, '') + '.js';
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }
  function refresh() {
    clearTimer();
    if (nativePending !== null) { stats.coalesced++; return Promise.resolve(count); }
    if (inFlight) { stats.coalesced++; return inFlight; }
    var startedRevision = revision, startedValue = valueRevision;
    dirty = false;
    stats.reads++;
    inFlight = window.fetch(cartUrl(), {credentials: 'same-origin', cache: 'no-store'})
      .then(function (response) {
        if (!response.ok) throw new Error('Cart count HTTP ' + response.status);
        return response.json();
      }).then(function (cart) {
        if (startedRevision !== revision || startedValue !== valueRevision) {
          stats.staleDiscarded++;
          return count;
        }
        if (Number.isInteger(cart.item_count)) { paint(cart.item_count); valueRevision++; }
        return count;
      }).catch(function (error) {
        // Preserve the last good count. Never overwrite it with zero on failure.
        api.lastCartCountError = String(error && error.message || error);
        return count;
      }).then(function (result) {
        inFlight = null;
        if (dirty && nativePending === null) schedule(0);
        return result;
      });
    return inFlight;
  }
  function schedule(delay) {
    clearTimer();
    timer = window.setTimeout(function () { timer = null; refresh(); }, delay);
  }
  function invalidate() {
    revision++;
    dirty = !!inFlight;
    nativePending = null;
    clearTimer();
    return revision;
  }
  function expectNative() {
    // Called by our existing CartSection immediately before its section request.
    var token = invalidate();
    nativePending = token;
    return token;
  }
  function acceptNative(value, token) {
    if (token != null && token !== revision) { stats.staleDiscarded++; return false; }
    clearTimer();
    nativePending = null;
    dirty = false;
    valueRevision++;
    stats.nativeResults++;
    return paint(value);
  }
  function failNative(token) {
    if (token !== revision) return;
    nativePending = null;
    dirty = true;
    refresh();
  }
  function onMutationSignal() {
    invalidate();
    // Give Prestige's same-event handler time to take ownership of the refresh.
    // If no CartSection handles this event, retain a read-only Ajax fallback.
    schedule(350);
  }
  api.cart = {
    refresh: refresh, paint: function () { paint(count); }, invalidate: invalidate,
    begin: expectNative, accept: acceptNative, fail: failNative,
    isCurrent: function (token) { return token == null || token === revision; },
    getCount: function () { return count; }, stats: stats
  };
  // Capture once: supports events dispatched on document or html, without duplicate listeners.
  document.addEventListener('cart:refresh', onMutationSignal, true);
  document.addEventListener('product:added', onMutationSignal, true);
  paint(count);
})(window, document);
